module.exports = __webpack_public_path__ + "img/logo-jp.ab292dfb.png";